/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const checkoutCartStyle = {
  paper: (theme: Theme)=> ({
    padding: "1.5rem",
    [theme.breakpoints.up("md")]: {
      padding: "2rem 3rem"
    }
  }),
  paperHeading: {
    color: "primary.main",
    marginBottom: 0,
    textAlign: "center",
  },
  table: {
    marginTop: "1rem",
  },
  tableCell: {
    fontSize: "1rem",
    padding: "0 10px 0 0",
    borderBottom: "none",
  },
  tableCellValue: {
    fontSize: "1rem",
    padding: "0 !important",
    borderBottom: "none",
    textAlign: "right",
    fontWeight: 500,
  },
  taxHint: {
    fontSize: "0.8rem",
    marginBottom: "1rem",
  },
  sealContainer: {
    marginTop: "1.5rem"
  },
  ssl: {
    maxWidth: "100%",
    maxHeight: "100%",
  },
  highlightBox: {
    textAlign: "center",
  },
};

export default checkoutCartStyle;
